'use strict';

function getLeadEnhancements(leadType, showContactALender, isLcmEnabled) {
  if (leadType === 'none') {
    return '';
  } else if (showContactALender) {
    if (isLcmEnabled) {
      return 'classic,lcm';
    } else {
      return 'classic,rcm';
    }
  } else {
    return 'classic';
  }
}

function getChannel(propertyType) {
  if (propertyType && propertyType.includes('rent')) {
    return 'rentals';
  } else {
    return 'homes';
  }
}

function getDataSourceType() {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments[1];

  if (flags.is_aptlist) {
    return 'aptlist';
  } else if (flags.is_costar) {
    return 'costar';
  } else {
    return source;
  }
}

function getLeadDelivery(propertyStatus, opts) {
  switch (propertyStatus) {
    case 'for_sale':
      return opts.leadType === 'none' ? '' : opts.leadType;
    case 'new_plan':
    case 'new_community':
      return 'showcase';
    case 'for_rent':
      if (opts.leadType === 'advantage_pro') {
        return 'advantage_pro';
      } else {
        return getDataSourceType(opts.flags, opts.source) !== 'mls' && opts.flags && opts.flags.is_showcase ? 'showcase' : 'basic';
      }
    case 'not_for_sale':
      return 'seller';
    default:
      return '';
  }
}

module.exports = {
  getLeadEnhancements: getLeadEnhancements,
  getChannel: getChannel,
  getDataSourceType: getDataSourceType,
  getLeadDelivery: getLeadDelivery
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/lead_helper.js
// module id = 920
// module chunks = 48 49 51